import React, { Component } from "react";
import { connect } from "react-redux";
import Content from "../../content/Content";
import Store from "../../content/Store";
import HomeCard from "./HomeCard";
import {
    ButtonConfig
  } from "../../constants/Constants";

export class SagaCard extends Component {
    static content = Store.Home;

    GetMatchedImage(matches, imgSrcMobile, imgSrc) {
        return matches ? (
            <img src={imgSrcMobile} alt="" aria-hidden />
        ) : (
            <img src={imgSrc} alt="" aria-hidden />
        );
    }

    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div
                        className={
                            "col-sm-12 col-lg-4"
                        }
                        data-explore-my-cover-home-card
                    >
                        <Content
                            names={[
                                Store.Home.Cards.HomeMyCoverSrc.IconSrc,
                                Store.Home.Cards.HomeMyCoverSrc.Heading,
                                Store.Home.Cards.HomeMyCoverSrc.Description,
                                Store.Home.Cards.HomeMyCoverSrc.LinkText,
                                Store.Home.Cards.HomeMyCoverSrc.LinkTo,
                                Store.Home.Cards.HomeMyCoverSrc.ExternalLinkTo
                            ]}
                        >
                            {(
                                iconSrc,
                                heading,
                                description,
                                linkText,
                                linkTo,
                                externalLinkTo
                            ) => (
                                <HomeCard
                                    IconSrc={iconSrc}
                                    Heading={heading}
                                    Description={description}
                                    LinkText={linkText}
                                    LinkTo={linkTo}
                                    ExternalLinkTo={externalLinkTo}
                                    id={ButtonConfig.HomeIndcta_mol_hp_trco}
                                />
                            )}
                        </Content>
                    </div>
                    <div className="col-sm-12 col-lg-4" data-claims-home-card>
                        <Content
                            names={[
                                Store.Home.Cards.HomeEAPpolicySrc.IconSrc,
                                Store.Home.Cards.HomeEAPpolicySrc.Heading,
                                Store.Home.Cards.HomeEAPpolicySrc.Description,
                                Store.Home.Cards.HomeEAPpolicySrc.LinkText,
                                Store.Home.Cards.HomeEAPpolicySrc.LinkTo,
                                Store.Home.Cards.HomeEAPpolicySrc.ExternalLinkTo
                            ]}
                        >
                            {(
                                iconSrc,
                                heading,
                                description,
                                linkText,
                                linkTo,
                                externalLinkTo
                            ) => (
                                <HomeCard
                                    IconSrc={iconSrc}
                                    Heading={heading}
                                    Description={description}
                                    LinkText={linkText}
                                    LinkTo={linkTo}
                                    ExternalLinkTo={externalLinkTo}
                                    id={ButtonConfig.HomeIndcta_mol_hp_docs}
                                />
                            )}
                        </Content>
                    </div>
                    <div
                        className="col-sm-12 col-lg-4"
                        data-access-health-support-home-card
                    >
                        <Content
                            names={[
                                Store.Home.Cards.HomeClaimSrc.IconSrc,
                                Store.Home.Cards.HomeClaimSrc.Heading,
                                Store.Home.Cards.HomeClaimSrc.Description,
                                Store.Home.Cards.HomeClaimSrc.LinkText,
                                Store.Home.Cards.HomeClaimSrc.LinkTo,
                                Store.Home.Cards.HomeClaimSrc.ExternalLinkTo
                            ]}
                        >
                            {(
                                iconSrc,
                                heading,
                                description,
                                linkText,
                                linkTo,
                                externalLinkTo
                            ) => (
                                <HomeCard
                                    IconSrc={iconSrc}
                                    Heading={heading}
                                    Description={description}
                                    LinkText={linkText}
                                    LinkTo={ linkTo
                                    }
                                    ExternalLinkTo={externalLinkTo}
                                    id={ButtonConfig.HomeIndcta_mol_hp_vcl}
                                />
                            )}
                        </Content>
                    </div>
                </div>
                <div  className={window.innerWidth>768 ?"row row-color justify-content-center":"row"} >
                    <div className="col-sm-12 col-lg-4" data-claims-home-card>
                        <Content
                            names={[
                                Store.Home.Cards.HomeclaimMoneySrc.IconSrc,
                                Store.Home.Cards.HomeclaimMoneySrc.Heading,
                                Store.Home.Cards.HomeclaimMoneySrc.Description,
                                Store.Home.Cards.HomeclaimMoneySrc.LinkText,
                                Store.Home.Cards.HomeclaimMoneySrc.LinkTo,
                                Store.Home.Cards.HomeclaimMoneySrc.ExternalLinkTo
                            ]}
                        >
                            {(
                                iconSrc,
                                heading,
                                description,
                                linkText,
                                linkTo,
                                externalLinkTo
                            ) => (
                                <HomeCard
                                    IconSrc={iconSrc}
                                    Heading={heading}
                                    Description={description}
                                    LinkText={linkText}
                                    LinkTo={linkTo}
                                    ExternalLinkTo={externalLinkTo}
                                    id={ButtonConfig.HomeIndcta_mol_hp_cp}
                                />
                            )}
                        </Content>
                    </div>
                    <div
                        className="col-sm-12 col-lg-4"
                        data-access-health-support-home-card
                    >
                        <Content
                            names={[
                                Store.Home.Cards.HomeTouchSrc.IconSrc,
                                Store.Home.Cards.HomeTouchSrc.Heading,
                                Store.Home.Cards.HomeTouchSrc.Description,
                                Store.Home.Cards.HomeTouchSrc.LinkText,
                                Store.Home.Cards.HomeTouchSrc.LinkTo,
                                Store.Home.Cards.HomeTouchSrc.ExternalLinkTo
                            ]}
                        >
                            {(
                                iconSrc,
                                heading,
                                description,
                                linkText,
                                linkTo,
                                externalLinkTo
                            ) => (
                                <HomeCard
                                    IconSrc={iconSrc}
                                    Heading={heading}
                                    Description={description}
                                    LinkText={linkText}
                                    LinkTo={  linkTo
                                    }
                                    ExternalLinkTo={externalLinkTo}
                                    id={ButtonConfig.HomeIndcta_mol_hp_mess}
                                />
                            )}
                        </Content>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export const mapStateToSagaCard = (state) => {
    const { IsLapsed: isLapsed, IsFormat2: isFormat2, IsSME: isSME } =
        state.policyReducer.selectedPolicy || {};
    return {
        IsSaga: state.policyReducer.selectedPolicy.IsSaga,
        isLapsed,
        isFormat2,
        isSME,
    };
};

export default connect(
    mapStateToSagaCard
)(SagaCard);
